import { render, staticRenderFns } from "./resource-request-details.vue?vue&type=template&id=9d4afdf0&scoped=true"
import script from "./resource-request-details.vue?vue&type=script&lang=js"
export * from "./resource-request-details.vue?vue&type=script&lang=js"
import style0 from "./resource-request-details.vue?vue&type=style&index=0&id=9d4afdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4afdf0",
  null
  
)

export default component.exports